export default __webpack_public_path__ + "static/media/success-icon.93c4b87a.svg";